import { CatalogueCategory } from '../../models/services/api/getCatalogue';

export function getCategoryFromApplianceCodeInCatalogue(
  applianceCode: string,
  catalogue?: CatalogueCategory[],
): CatalogueCategory | undefined {
  if (catalogue) {
    return catalogue.find((item) =>
      item.appliances?.some((appliance) => appliance.applianceCode === applianceCode),
    );
  } else {
    return undefined;
  }
}
